<template>
    <Section v-if="product" class="checkout-ferry">
        <template #left>
            <FerryForm :product="product" :sectionId="sectionId" />
        </template>
        <template #right>
            <FerryDetails :product="product" :sectionId="sectionId" />
        </template>
    </Section>
</template>

<script lang="ts">
    import { computed, defineComponent } from 'vue';
    import { t } from '@shared/helpers/translation';
    import { useStore } from '@/store';
    import { FerryProduct } from '@/api/Cart/cart.interfaces';
    import FerryForm from '@/components/checkoutPageV3/Sections/Products/Ferry/Form/Form.vue';
    import FerryDetails from '@/components/checkoutPageV3/Sections/Products/Ferry/Details/Details.vue';
    import Section from '@/components/checkoutPageV3/Shared/Section/Section.vue';

    export default defineComponent({
        name: 'Ferry',
        methods: { t },
        components: { Section, FerryDetails, FerryForm },
        props: {
            sectionId: { type: String, required: true },
            productId: { type: String, required: true },
        },
        setup(props) {
            const store = useStore();

            const product = computed<FerryProduct | undefined>(() =>
                store.getters['cart/getProduct'](props.productId)
            );

            return { product };
        },
    });
</script>

<style lang="scss">
    @forward 'Ferry.scss';
</style>
